import React from "react";
import CardContainer from "./Card";

const CardLists = ({ data }: { data: any }) => {
    const payload = [
        {
            title: "Amount in Wallet",
            value: data?.walletBalance ? data?.walletBalance : "0",
            bgColor: "#FFFFFF"
        },
        {
            title: "Number of Customers",
            value: data?.numberOfCustomers ?? 0,
            bgColor: "#FFFFFF"
        },
        {
            title: "Number of Orders",
            value: data?.numberOfOrders ?? 0,
            bgColor: "#FFFFFF"
        },

        {
            title: "Awaiting Result",
            value: data?.numberOfAwaitingResults ?? 0,
            bgColor: "#FFFFFF"
        }
    ];

    return (
        <div className="">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-12">
                {payload.map((value) => (
                    <CardContainer key={value?.title} data={value} />
                ))}
            </div>
        </div>
    );
};

export default CardLists;
